import { Badge, Group, List, Stack, Text } from '@mantine/core'
import { useTranslate } from 'react-admin'
import { GetApiPrepaymentsIdRegenerationImpact200StatementsItem } from '../../codegen/generated/Api.schemas'
import { LXLoader } from '../LXLoader'

type PrepaymentStatementsUpdateProps = {
  statements: GetApiPrepaymentsIdRegenerationImpact200StatementsItem[]
  loading: boolean
}
export const PrepaymentStatementsUpdate = ({
  statements,
  loading,
}: PrepaymentStatementsUpdateProps) => {
  const t = useTranslate()

  if (loading) {
    return <LXLoader size="md" />
  }

  if (statements.length === 0) {
    return
  }

  return (
    <Stack mt="xl">
      <Text size="sm" fs="italic">
        {t('pages.prepayments.followingStatementsImpactedByChanges')}:
      </Text>
      <List ml="sm">
        {statements.map(s => (
          <List.Item>
            <Group>
              <Text>
                {s.month} / {s.year}
              </Text>
              {s?.paidAt ? (
                <Badge color="green" size="xs">
                  {t('pages.statements.paid')}
                </Badge>
              ) : (
                <Badge color="yellow" size="xs" w="4rem" pt="0.1rem">
                  {t('pages.statements.notPaid')}
                </Badge>
              )}
            </Group>
          </List.Item>
        ))}
      </List>
    </Stack>
  )
}
